import { render, staticRenderFns } from "./ConsumablesTable.vue?vue&type=template&id=1524c1fe&scoped=true&"
import script from "./ConsumablesTable.vue?vue&type=script&lang=js&"
export * from "./ConsumablesTable.vue?vue&type=script&lang=js&"
import style0 from "./ConsumablesTable.vue?vue&type=style&index=0&id=1524c1fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524c1fe",
  null
  
)

export default component.exports